import { render, staticRenderFns } from "./ApprovalInfoDetail.vue?vue&type=template&id=6e152d04&scoped=true&"
import script from "./ApprovalInfoDetail.vue?vue&type=script&lang=js&"
export * from "./ApprovalInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalInfoDetail.vue?vue&type=style&index=0&id=6e152d04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e152d04",
  null
  
)

export default component.exports